import * as React from 'react'
import { TTAvatar } from '../TTAvatar'

interface FSAvatarProps {
    directory: boolean
}

export const FSAvatar: React.FC<FSAvatarProps> = (props) => {
    return <TTAvatar tticon={props.directory ? "cartella" : "documento"} />
}